export const SERVER_URL = "https://do-calculate.com/api";

export const Period_EndPoint = "calculate-period";
export const Conception_EndPoint = "calculate-conception";
export const Ovulation_EndPoint = "calculate-ovulation";
export const DueDate_EndPoint = "calculate-due-date";
export const PregnancyConception_EndPoint = "calculate-pregnancy-conception";
export const WeightGainPregnancyCalculate_EndPoint =
  "calculate-pregnancy-weight-gain";
export const PregnancyCalculate_EndPoint = "calculate-pregnancy";

export const womenCalculators_Fr = [
  // EXISTING CALCULATORS
  {
    name: "Calculatrice du cycle menstruel",
    link: "/calculator/fr/period/",
    description:
      "Ce calculateur aide à suivre le cycle menstruel et à déterminer les périodes fertiles.",
    showMain: true,
  },
  {
    name: "Calculatrice de grossesse",
    link: "/calculator/fr/pregnancy/",
    description:
      "Ce calculateur est utilisé pour calculer la date prévue d'accouchement et estimer la semaine actuelle de grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date de conception pendant la grossesse",
    link: "/calculator/fr/pregnancy-conception/",
    description:
      "Ce calculateur calcule la date de conception pendant la grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date prévue d'accouchement",
    link: "/calculator/fr/pregnancy-due-date/",
    description:
      "Ce calculateur est utilisé pour estimer la date prévue d'accouchement en fonction de la date du début de la grossesse.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date d'ovulation",
    link: "/calculator/fr/ovulation/",
    description:
      "Ce calculateur aide à estimer la date d'ovulation et le meilleur moment pour la conception.",
    showMain: true,
  },
  {
    name: "Calculatrice de la date de conception",
    link: "/calculator/fr/conception/",
    description:
      "Ce calculateur est utilisé pour calculer la date de conception en fonction de votre cycle menstruel et de la durée du cycle.",
    showMain: true,
  },

  // NEW WOMEN CALCULATORS (8)
  {
    name: "Calculatrice de taille de soutien-gorge",
    link: "/calculator/fr/bra-size-calculator/",
    description:
      "Trouvez votre taille de soutien-gorge correcte avec cette calculatrice.",
    showMain: true,
  },

  {
    name: "Calculatrice de l'âge gestationnel",
    link: "/calculator/fr/gestational-age-calculator/",
    description:
      "Calculez l'âge gestationnel de votre grossesse.",
    showMain: true,
  },

];
